import React from 'react'
import { Box, TextField, Alert, Typography } from '@mui/material'
import Api from '../../Api'
import LoadingDefault from '../Elements/Loading/LoadingDefault'
import { StyledButton } from '@/Components/Elements/StyledComponents/Buttons'

interface TwoFactorAuthenticationProps {
    kedo: any
    username: string
    password: string
    onSuccess: (data: any) => void
}

interface TwoFactorAuthenticationState {
    otpKey: string
    password: string
    username: string
    loading?: boolean
    loginErrors?: boolean
}

export default class TwoFactorAuthentication extends React.Component<
    TwoFactorAuthenticationProps,
    TwoFactorAuthenticationState
> {
    constructor(props: TwoFactorAuthenticationProps) {
        super(props)

        this.state = {
            otpKey: '',
            password: this.props.password,
            username: this.props.username,
        }

        this.onSubmit = this.onSubmit.bind(this)
    }

    onSubmit(event: React.FormEvent<HTMLFormElement>): void {
        event.preventDefault()
        if (!this.state.otpKey || this.state.otpKey.length <= 0) {
            return
        }

        const api = new Api()
        this.setState({
            loading: true,
            loginErrors: false,
        })
        api.post(
            '/login_check',
            { username: this.props.username, password: this.props.password },
            { headers: { 'X-OTP-Token': this.state.otpKey } }
        )
            .then((response: any) => {
                if (response.data) {
                    this.props.onSuccess(response.data)
                }
                this.setState({ loading: false })
            })
            .catch((err: any) => {
                this.setState({
                    loading: false,
                    loginErrors: true,
                })
            })
    }

    reload(): void {
        window.location.reload()
    }

    onHandlePincodeChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const pincode = e.target.value

        if (
            (e as any).keyCode !== 48 &&
            (e as any).keyCode !== 8 &&
            !Number(pincode) &&
            pincode !== '' &&
            pincode !== '0' &&
            pincode !== '00' &&
            pincode !== '000' &&
            pincode !== '0000' &&
            pincode !== '00000' &&
            pincode !== '000000'
        ) {
            return
        }
        this.setState({
            [e.target.name]: pincode,
        } as Pick<TwoFactorAuthenticationState, keyof TwoFactorAuthenticationState>)
    }

    render() {
        const kedo = this.props.kedo

        return (
            <Box component="form" onSubmit={this.onSubmit}>
                <Typography
                    variant="h4"
                    gutterBottom
                    sx={{ fontWeight: '500' }}
                >
                    {kedo.t('Verification code')}
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    {kedo.t('Enter your verification code below')}.
                    <br />
                    {kedo.t('Use your authentication device')}
                </Typography>
                {this.state.loginErrors && (
                    <Alert severity="error" sx={{ mb: 2 }}>
                        {kedo.t('Incorrect verification code')}.
                    </Alert>
                )}
                <TextField
                    type="text"
                    name="otpKey"
                    fullWidth
                    size="small"
                    inputProps={{ maxLength: 6 }}
                    autoFocus
                    autoComplete="off"
                    value={this.state.otpKey}
                    placeholder={kedo.t('Verification code')}
                    onChange={this.onHandlePincodeChange}
                    required
                    sx={{ mb: 2 }}
                />
                <StyledButton
                    fullWidth
                    color="primary"
                    type="submit"
                    disabled={!this.state.otpKey || this.state.loading}
                    title={
                        !this.state.otpKey
                            ? 'Enter a verification code to continue'
                            : undefined
                    }
                    sx={{ mb: 2, '& svg': { ml: 1 } }}
                >
                    {kedo.t('Verify')}{' '}
                    {this.state.loading && <LoadingDefault />}
                </StyledButton>
                <StyledButton
                    fullWidth
                    variant="text"
                    color="primary"
                    dense
                    onClick={this.reload}
                >
                    {kedo.t('Back to')} {kedo.t('Login').toLowerCase()}
                </StyledButton>
            </Box>
        )
    }
}
